module.exports = __webpack_public_path__ + "static/logo-alam-bali-9f4930c0c2c6198a01db41d5a6c1f558.png";